export default __webpack_public_path__ + "static/clever_group-96ad550d11d25aefd66bc621879cad97.png";